import React from "react";

const StepCard = ({ step, title, done, children }) => {
  return (
    <div
      className={`bg-white rounded-xl shadow-md p-6 border-2 transition-all duration-300 ${done ? 'border-green-400' : 'border-blue-200'} relative`}
    >
      <div className="flex items-center mb-4">
        <div className={`w-8 h-8 flex items-center justify-center rounded-full mr-3 text-lg font-bold ${done ? 'bg-green-400 text-white' : 'bg-blue-200 text-blue-700'}`}>{step}</div>
        <h2 className="text-xl font-semibold flex-1">{title}</h2>
        {done && <span className="ml-2 text-green-500 text-2xl">✔</span>}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default StepCard; 